exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header-container3 {\n  color: #f9fafc;\n}\n.list-content {\n  padding-left: 25px;\n}\n.blink_me {\n  animation: blinker 1s linear infinite;\n  color: yellow;\n}\n@keyframes blinker {\n  50% {\n    opacity: 0;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/components/views/HomeContent.css
// module id = 111
// module chunks = 0